export default {
  "auth.loginTitle": "Iniciar sesión",
  "auth.loginSubtitle": "Bienvenido de vuelta a BajApp Xperiences",
  "auth.registerTitle": "Crear cuenta",
  "auth.registerSubtitle": "Únete a la comunidad de BajApp Xperiences",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.confirmPassword": "Confirmar contraseña",
  "auth.fullName": "Nombre completo",
  "auth.phone": "Teléfono",
  "auth.forgotPassword": "¿Olvidaste tu contraseña?",
  "auth.rememberMe": "Recordarme",
  "auth.loginBtn": "Iniciar sesión",
  "auth.registerBtn": "Registrarse",
  "auth.noAccount": "¿No tienes cuenta?",
  "auth.hasAccount": "¿Ya tienes cuenta?",
  "auth.signUp": "Regístrate",
  "auth.signIn": "Inicia sesión",
  "auth.or": "o",
  "auth.google": "Continuar con Google",
  "auth.facebook": "Continuar con Facebook",
  "auth.chooseRoleTitle": "Crear cuenta",
  "auth.chooseRoleSubtitle": "¿Cómo quieres unirte a BajApp Xperiences?",
  "auth.travelerCardTitle": "Soy turista",
  "auth.travelerCardDesc": "Reserva tours, experiencias, transporte y hospedaje en Baja California Sur.",
  "auth.continueAsTraveler": "Continuar como turista",
  "auth.providerCardTitle": "Soy proveedor",
  "auth.providerCardDesc": "Publica tus tours, vehículos o propiedades y empieza a recibir reservas.",
  "auth.continueAsProvider": "Continuar como proveedor",
  "auth.registerClientTitle": "Regístrate como turista",
  "auth.registerClientSubtitle": "Crea tu cuenta de turista",
  "auth.registerProviderTitle": "Regístrate como proveedor",
  "auth.registerProviderSubtitle": "Crea tu cuenta de proveedor",
  "auth.verifyingEmail": "Revisa tu correo",
  "auth.checkInbox": "Te enviamos un enlace de verificación. Por favor revisa tu bandeja de entrada.",
  "auth.forgotTitle": "¿Olvidaste tu contraseña?",
  "auth.forgotSubtitle": "Ingresa tu correo y te enviaremos un enlace para restablecerla.",
  "auth.forgotSentTitle": "Correo enviado",
  "auth.forgotSentDesc": "Si existe una cuenta con ese correo, recibirás un enlace de restablecimiento en breve.",
  "auth.backToLogin": "Volver al inicio de sesión",
  "auth.sendResetLink": "Enviar enlace",
  "auth.resetTitle": "Restablecer contraseña",
  "auth.resetSubtitle": "Ingresa tu nueva contraseña a continuación.",
  "auth.newPassword": "Nueva contraseña",
  "auth.resetBtn": "Restablecer contraseña",
  "auth.resetSuccessTitle": "Contraseña actualizada",
  "auth.resetSuccessDesc": "Tu contraseña se cambió correctamente. Ahora puedes iniciar sesión.",
  "auth.verifyVerifyingTitle": "Verificando correo...",
  "auth.verifyVerifyingDesc": "Por favor espera mientras verificamos tu dirección de correo.",
  "auth.verifySuccessTitle": "Correo verificado",
  "auth.verifySuccessDesc": "Tu correo se verificó correctamente. Ahora puedes iniciar sesión en tu cuenta.",
  "auth.verifyErrorTitle": "Verificación fallida",
  "auth.verifyErrorDesc": "El enlace de verificación es inválido o ha expirado. Por favor intenta de nuevo.",
  "auth.resendEmail": "Reenviar correo",
  "auth.registerAgain": "Registrarse de nuevo",
  "auth.providerCompany": "Nombre del negocio",
  "auth.providerRfc": "RFC (opcional)",
  "auth.providerLocation": "Ubicación del negocio",
  "auth.providerDesc": "¿Qué servicios ofreces?",
  "auth.terms": "Al registrarte aceptas nuestros términos y política de privacidad",
  "auth.acceptsMarketing": "Quiero recibir ofertas, promociones y novedades por correo. Puedes darte de baja en cualquier momento.",
  "auth.required": "Campo requerido",
  "auth.invalidEmail": "Correo inválido",
  "auth.showPassword": "Mostrar contraseña",
  "auth.hidePassword": "Ocultar contraseña",
  "auth.passwordMin": "Mínimo 8 caracteres",
  "auth.passwordMatch": "Las contraseñas no coinciden",
  "auth.errEmailTaken": "Este correo ya está registrado",
  "auth.errInvalidCreds": "Correo o contraseña incorrectos",
  "auth.errGeneric": "Algo salió mal. Inténtalo de nuevo.",
  "auth.submitting": "Procesando...",
  "auth.clientTab": "Soy turista",
  "auth.providerTab": "Soy proveedor",
  "auth.unknownError": "Ocurrió un error inesperado.",
  "auth.resetTokenMissing": "Falta el token en el enlace.",
  "auth.goToAccount": "Ir a mi cuenta",
  "auth.comingSoon": "Próximamente",
  "auth.loadingGoogle": "Cargando Google…",
  "auth.googleNotConfigured": "El inicio de sesión con Google no está configurado (VITE_GOOGLE_CLIENT_ID)",
  "auth.googleLoadError": "No se pudo cargar Google.",
};